import { uniqueString } from '../util';
import { Question, ActionGetContext, } from '../Actions';
import { FlowActionNames } from '../Flows';
export function addQuestionAttempt(state, attempt) {
    return Object.assign({}, state, { question: Object.assign({}, state.question, { attempts: [...state.question.attempts, attempt] }) });
}
export function completeInteraction(state) {
    return Object.assign({}, state, { isComplete: true });
}
export function createSmsCookie(req) {
    return {
        createdAt: new Date(),
        flow: null,
        flowContext: {},
        flowKey: 0,
        from: req.body.From,
        interactionComplete: false,
        interactionContext: [],
        interactionId: uniqueString(),
        isComplete: false,
        question: {
            attempts: [],
            isAnswering: false,
        },
    };
}
export function handleTrigger(state, trigger) {
    return Object.assign({}, state, { flow: trigger.flowName, flowKey: 0, flowContext: {} });
}
export function incrementFlowAction(state, flow) {
    const newState = Object.assign({}, state);
    newState.flowKey = Number(state.flowKey) + 1;
    if (newState.flowKey === flow.length) {
        return completeInteraction(state);
    }
    return newState;
}
export function startQuestion(state) {
    return Object.assign({}, state, { question: {
            attempts: [],
            isAnswering: true,
        } });
}
function recordQuestionMessageSid(state, question) {
    const prevSids = ((state.flowContext[question.name] || {}).messageSid || []);
    return [
        ...prevSids,
        ...(question.sid || []),
    ];
}
function getActionContext(state, flow, action) {
    return (action instanceof Question ?
        Object.assign({}, action[ActionGetContext](), { messageSid: recordQuestionMessageSid(state, action) }) : action[ActionGetContext]());
}
export function updateContext(state, flow, action) {
    if (!state)
        return null;
    if (!flow[FlowActionNames].has(action.name)) {
        throw new Error(`Flow ${flow.name} does not have an action named ${action.name}`);
    }
    if (!state.flow)
        state.flow = flow.name;
    return Object.assign({}, state, { flowContext: Object.assign({}, state.flowContext, { [action.name]: getActionContext(state, flow, action) }), interactionContext: [
            ...state.interactionContext,
            Object.assign({}, getActionContext(state, flow, action), { flowName: flow.name }),
        ] });
}
